import React from 'react'
import TimelapseDateSlider from './TimelapseDateSlider'
import ReactTooltip from 'react-tooltip'

import next from '../images/next.svg';
import pause from '../images/pause.svg';
import play from '../images/play.svg';
import previous from '../images/previous.svg';
import replay from '../images/replay.svg'
import './TimelapseControls.scss'

const playbackSpeeds = [
  { value: 0.25, label: '0.5x'},
  { value: 0.5, label: '1x'},
  { value: 1, label: '2x'},
]
const casesDeathsOptions = [{ label: 'Cases', value: 'cases'}, { label: 'Fatalities', value: 'deaths'}
]
export default function TimelapseControls(props) {

  const {
    setPaused,
    paused,
    setDateIndex,
    dateIndex,
    casesDeathsMetricKey,
    setCasesDeathsMetricKey,
    playbackSpeed,
    setPlaybackSpeed,
    dateSet,
  } = props


  return (
    <div>
      <div className='controlContainer'>
        <div className='range'>
          <TimelapseDateSlider
            {...props}
          />
        </div>
        <div className='otherControls'>
          <div className='dateControls'>
            <div className='control play' onClick={() => {
              setPaused(paused => !paused)
              if (dateIndex === dateSet.length - 1) {
                setDateIndex(0)
              }
            }}>
              <img
                src={
                  paused ?
                    (dateIndex === dateSet.length - 1 ? replay : play)
                    : pause
                }
                alt={paused ? 'play' : 'pause'}
                data-tip={paused ? 'Play' : 'Pause'}
              />
            </div>

            <div
              className='control previous'
              onClick={() => {
                const nextDateIndex = dateIndex - 1;
                if (nextDateIndex >= 0) {
                  setDateIndex(nextDateIndex)
                }
              }}
              data-tip='Previous Day'
            >
              <img src={previous} alt='previous' />
            </div>
            <div
              className='control next'
              onClick={() => {
                const nextDateIndex = dateIndex + 1;
                if (nextDateIndex < dateSet.length) {
                  setDateIndex(nextDateIndex)
                }
              }}
              data-tip='Next Day'
            >
              <img src={next} alt='next' />
            </div>
          </div>
          <div className='playbackSpeed' data-tip='Speed'>
            {playbackSpeeds.map(({ value, label}) => {
              return (
                <div
                  key={value}
                  className={value === playbackSpeed ? 'selected' : ''}
                  onClick={() => setPlaybackSpeed(value)}
                >
                  {label}
                </div>
              )
            })}

          </div>
        </div>
      </div>
      <div className='bottomControls'>
        <div className='casesDeaths'>
          {casesDeathsOptions.map(({label, value}) => {
            return (
              <div
                key={value}
                className={value === casesDeathsMetricKey ? 'selected' : ''}
                onClick={() => setCasesDeathsMetricKey(value)}
              >
                {label}
              </div>
            )
          })}
        </div>
      </div>
      <ReactTooltip
        offset={{ top: -22, left: 0 }}
        effect='solid'
        place='top'
        type='light'
        className='reactTooltip'
        overridePosition={
          (position, currentEvent, currentTarget, node ) => {
            // console.log(position, node)
            const w = node.getBoundingClientRect().width
            return {
              top: position.top,
              left: position.left + w / 2,
            }
          }
        }
      />

    </div>
  )
}